<template>
  <v-chart class="chart" :option="option" />
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
]);

export default {
  name: "gauge",
  components: {
    VChart,
  },
  //背景颜色
  provide: {
    [THEME_KEY]: "",
  },
  props: {
    data: {
      type: Array,
    },
  },
  data() {
    return {
      option: {
        title: {
          text: "68#液压油 冷喷液 热喷液",
          textStyle: {
            color: "#fff",
            fontSize: 12,
          },
          top: 25,
          left: 30,
        },
        color: ["#fc8452", "#9a60b4", "#ea7ccc"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          top: 25,
          right: 15,
          data: [
            { name: "液压油", icon: "circle",itemStyle:{
              color:'#f6ce1d'
            } },
            { name: "冷喷液", icon: "circle",itemStyle:{
              color:'#5be2ff'
            } },
            { name: "热喷液", icon: "circle",itemStyle:{
              color:'#f0817f'
            }  },
          ],
          textStyle: {
            fontSize: 10,
            color: "#fff",
          },
          itemWidth: 10,
          itemHight: 10,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          //   boundaryGap: [0, 0.01],
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
        yAxis: {
          type: "category",
          data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        series: this.data,
      },
    };
  },
  watch:{
    data(newVal) {
      this.option.series = newVal 
    }
  }
};
</script>

<style scoped>
.chart {
  width: 400px;
  height: 300px;
}
</style>


// WEBPACK FOOTER //
// src/components/test10Children/fracking.vue